import { Container } from "react-bootstrap";
import { Outlet, type LinksFunction } from "react-router";
import { AOSWrapper } from "~/components/utils/AOSWrapper";
import type { Route } from "./+types/layout";

import stylesAOS from "aos/dist/aos.css?url";
import stylesGlobal from "~/styles/global.css?url";
import stylesBS from 'bootstrap/dist/css/bootstrap.min.css?url';
import NavBar from "./nav/navBar";
import { getMenuItems } from "~/data/courses.server";
import { defaultMeta, handle, mergeMeta } from "~/lib/meta";
import { canonical } from "~/utils/meta";

const url = '/';

export default function LayoutPublic() {
    return (
        <div id="root">
            <Container fluid data-con-theme="social">
                <NavBar />
                <AOSWrapper
                    options={{ duration: 700, once: true }}
                    refreshOn="all"                 // refresh on path/search/hash changes
                    observeMutations                // auto-refresh when DOM changes
                    hardRefreshOnRouteChange={false}
                    mutationDebounceMs={150}
                >
                    <Outlet />
                </AOSWrapper>
            </Container>
        </div>
    );
}

export const links: LinksFunction = () => [
    { rel: "stylesheet", href: stylesAOS },
    { rel: "stylesheet", href: stylesBS },
    { rel: "stylesheet", href: stylesGlobal },
];

export async function loader() {
    try {

        const menuData = await getMenuItems();

        if (!menuData.success) {
            console.error("Failed to fetch menu items:", menuData.error);
            return [];
        }
        return menuData.data || [];
    } catch (error) {
        console.error("Error fetching menu items:", error);
        return [];
    }
}



export function meta({ }: Route.MetaArgs) {
    return mergeMeta(
    defaultMeta(),
    [
        { tagName: "link", rel: "canonical", href: canonical(url) },
    ]
  );
}